import { isEqual } from 'date-fns';
import { useMemo, useRef } from 'react';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { useFocus, useKeyDown } from '../../hooks';
import { getMonthNumber, getTargetMonthByArrowKeyType } from '../../utilities';
import { jsx as _jsx } from "react/jsx-runtime";
export var MonthSelectionCell = _ref => {
  var {
    month,
    isActiveMonth,
    goToYear,
    focusedMonth,
    onFocusMonthChange,
    handleEscape,
    onBlurMonth,
    isActiveYear
  } = _ref;
  var {
    size,
    isMobileDatePicker
  } = useCalendarContext();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  var monthItemRef = useRef(null);
  var isFocusedMonth = useMemo(() => focusedMonth && isEqual(focusedMonth, month.date), [focusedMonth, month]);
  var {
    isFirstMonth
  } = getMonthNumber(month.date);
  var {
    onKeyDown
  } = useKeyDown({
    handleArrowKey: key => {
      var targetDate = getTargetMonthByArrowKeyType(key, month.date);

      if (targetDate) {
        onFocusMonthChange(targetDate);
      }
    },
    handleSelectKey: () => goToYear(month.date),
    handleEscape,
    handleBlur: onBlurMonth
  });
  var {
    onFocus,
    onBlur
  } = useFocus({
    ref: monthItemRef,
    isFocused: isFocusedMonth,
    handleOnFocus: () => {
      onFocusMonthChange(month.date);
    },
    handleOnBlur: () => {
      onFocusMonthChange(undefined);
    }
  }); // The focusable month is the focused month or active month in the active year, otherwise is the first month of the year.

  var defaultFocusableMonth = isActiveYear ? isActiveMonth : isFirstMonth;
  var isFocusable = focusedMonth ? isFocusedMonth : defaultFocusableMonth;
  return /*#__PURE__*/_jsx(Box, {
    as: "button",
    "data-active": isActiveMonth || null,
    __css: styles['monthSelectionCell'],
    onClick: () => goToYear(month.date),
    "aria-disabled": month.isDisabled,
    "data-testid": "year-selection-month",
    "aria-label": "Month ".concat(month.fullLabel),
    "aria-checked": isActiveMonth,
    tabIndex: isFocusable ? 0 : -1,
    role: "radio",
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: monthItemRef,
    children: month.label
  });
};
//# sourceMappingURL=MonthSelectionCell.js.map